import { render, staticRenderFns } from "./CustomerIdentity.vue?vue&type=template&id=c473d8c8&"
import script from "./CustomerIdentity.vue?vue&type=script&lang=js&"
export * from "./CustomerIdentity.vue?vue&type=script&lang=js&"
import style0 from "./CustomerIdentity.vue?vue&type=style&index=0&id=c473d8c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports